import { render, staticRenderFns } from "./InformeSpam.vue?vue&type=template&id=2975b531&scoped=true"
import script from "./InformeSpam.vue?vue&type=script&lang=js"
export * from "./InformeSpam.vue?vue&type=script&lang=js"
import style0 from "./InformeSpam.vue?vue&type=style&index=0&id=2975b531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975b531",
  null
  
)

export default component.exports